import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../../HandleAPICalls/actions";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditRuleComponent from "./component";
import Sidebar from "../../../../Navigation/Sidebar/Sidebar";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const EditRuleContainer = (props) => {
  const [loading, setLoading] = useState(false);
  
  const [corporateId, setCorporateId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const [ruleId, setRuleId] = useState(null);
  const [departmentName, setDepartmentName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [pgid, setPgid] = useState(null);
  const [accountType, setAccountType] = useState(null);
  
  const [resetEnabled, setResetEnabled] = useState(false);
  const [carryForwardEnabled, setCarryForwardEnabled] = useState(false);
  const [resetConfig, setResetConfig] = useState({
    amount: "",
    frequency: "MONTHLY",
    day: 2,
  });
  const [carryForwardConfig, setCarryForwardConfig] = useState({
    amount: "",
    lowBalance: "",
    frequency: "MONTHLY",
    day: 2,
  });
  
  const [existingRuleData, setExistingRuleData] = useState(null);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const getRuleIdFromParams = () => {
    if (params.ruleId) {
      return params.ruleId;
    }
    if (location.state?.ruleId) {
      return location.state.ruleId;
    }
    return null;
  };

  const getPgIdFromAccountType = (accountTypeValue) => {
    if (accountTypeValue === "wallet" || accountTypeValue === "WALLET") {
      return "8";
    } else if (accountTypeValue === "wallet-RFID" || accountTypeValue === "WALLET_RFID" || accountTypeValue === "WALLET-RFID") {
      return "11";
    }
    return "11";
  };

  useEffect(() => {
    if (params.corporateId && params.departmentId) {
      const corpId = parseInt(params.corporateId);
      const deptId = parseInt(params.departmentId);
      const ruleIdFromParams = getRuleIdFromParams();
      
      setCorporateId(corpId);
      setDepartmentId(deptId);
      
      if (ruleIdFromParams) {
        setRuleId(ruleIdFromParams);
      }
      
      let finalPgid = queryParams.get('pgId');
      
      const accountTypeFromQuery = queryParams.get('accountType');
      if (accountTypeFromQuery) {
        setAccountType(accountTypeFromQuery);
        if (!finalPgid) {
          finalPgid = getPgIdFromAccountType(accountTypeFromQuery);
        }
      }
      
      if (location.state?.pgid) {
        finalPgid = location.state.pgid;
      }
      
      if (location.state?.accountType) {
        setAccountType(location.state.accountType);
        if (!finalPgid) {
          finalPgid = getPgIdFromAccountType(location.state.accountType);
        }
      }
      
      if (!finalPgid) {
        finalPgid = "11";
      }
      
      setPgid(finalPgid);
      
      if (location.state && location.state.departmentName) {
        setDepartmentName(location.state.departmentName);
      }
      
      fetchExistingRule(corpId, deptId, ruleIdFromParams, finalPgid);
    } else {
      toast.error("Missing parameters in URL");
      setShowForm(true);
      setIsLoading(false);
    }
  }, [params, location]);

  const fetchExistingRule = (corpId, deptId, ruleIdValue, pgidValue) => {
    setIsLoading(true);
    setApiError(false);
    
    let url = `/partner/api/v1/recharge-rules/corporate/${corpId}/department/${deptId}/rule/${ruleIdValue}`;
    
    const queryParamsList = [];
    
    if (pgidValue) {
      queryParamsList.push(`pgId=${pgidValue}`);
    }
    
    if (accountType && accountType !== "null") {
      queryParamsList.push(`accountType=${accountType}`);
    }
    
    if (queryParamsList.length > 0) {
      url += `?${queryParamsList.join('&')}`;
    }
    
    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        setIsLoading(false);
        setShowForm(true);
        
        if (response) {
          const ruleData = response;
          setExistingRuleData(ruleData);
          
          if (ruleData.reset) {
            setResetEnabled(true);
            setResetConfig({
              amount: ruleData.reset.amount || "",
              frequency: ruleData.reset.frequency || "MONTHLY",
              day: ruleData.reset.day || 2,
            });
          } else {
            setResetEnabled(false);
          }
          
          if (ruleData.carryForward) {
            setCarryForwardEnabled(true);
            setCarryForwardConfig({
              amount: ruleData.carryForward.amount || "",
              lowBalance: ruleData.carryForward.lowBalance || "",
              frequency: ruleData.carryForward.frequency || "MONTHLY",
              day: ruleData.carryForward.day || 2,
            });
          } else {
            setCarryForwardEnabled(false);
          }
          
          toast.success("Rule data loaded successfully");
        } else {
          toast.info("No existing rule found. You can create new rules.");
          setResetEnabled(false);
          setCarryForwardEnabled(false);
          setApiError(false);
        }
      },
      (err) => {
        setIsLoading(false);
        setShowForm(true);
        setApiError(true);
        console.error("API Error:", err);
        toast.warning("Could not load existing rule data.");
      }
    );
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleResetConfigChange = (field, value) => {
    if (!resetEnabled) return;
    setResetConfig(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCarryForwardConfigChange = (field, value) => {
    if (!carryForwardEnabled) return;
    setCarryForwardConfig(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleResetFrequencyChange = (frequency) => {
    if (!resetEnabled) return;
    setResetConfig(prev => ({
      ...prev,
      frequency: frequency,
      day: null
    }));
  };

  const handleCarryForwardFrequencyChange = (frequency) => {
    if (!carryForwardEnabled) return;
    setCarryForwardConfig(prev => ({
      ...prev,
      frequency: frequency,
      day: null
    }));
  };

  const handleResetDayChange = (day) => {
    if (!resetEnabled) return;
    setResetConfig(prev => ({
      ...prev,
      day: day
    }));
  };

  const handleCarryForwardDayChange = (day) => {
    if (!carryForwardEnabled) return;
    setCarryForwardConfig(prev => ({
      ...prev,
      day: day
    }));
  };

  const handleResetDateSelect = (date) => {
    if (!resetEnabled) return;
    setResetConfig(prev => ({
      ...prev,
      day: date
    }));
  };

  const handleCarryForwardDateSelect = (date) => {
    if (!carryForwardEnabled) return;
    setCarryForwardConfig(prev => ({
      ...prev,
      day: date
    }));
  };

  const handleUpdateRule = () => {
    setLoading(true);
    
    // Build base payload
    const payload = {
      corporateId: corporateId,
      departmentId: departmentId,
      pgId: pgid
    };
    
    // Add reset payload only if reset is enabled
    if (resetEnabled) {
      const resetPayload = {
        enabled: true,
        amount: parseFloat(resetConfig.amount),
        frequency: resetConfig.frequency
      };
      
      // Add day only for WEEKLY or MONTHLY (not for DAILY)
      if (resetConfig.frequency !== "DAILY" && resetConfig.day) {
        resetPayload.day = resetConfig.day;
      }
      
      payload.reset = resetPayload;
    }
    
    // Add carryForward payload only if carry forward is enabled
    if (carryForwardEnabled) {
      const carryForwardPayload = {
        enabled: true,
        amount: parseFloat(carryForwardConfig.amount),
        lowBalance: parseFloat(carryForwardConfig.lowBalance),
        frequency: carryForwardConfig.frequency
      };
      
      // Add day only for WEEKLY or MONTHLY (not for DAILY)
      if (carryForwardConfig.frequency !== "DAILY" && carryForwardConfig.day) {
        carryForwardPayload.day = carryForwardConfig.day;
      }
      
      payload.carryForward = carryForwardPayload;
    }

    console.log("Update Payload:", JSON.stringify(payload, null, 2));

    let redirectUrl = `/home/customermanager/corporate/rules/${corporateId}`;
    if (accountType) {
      redirectUrl += `?accountType=${accountType}`;
    }

    props.getDataFromAPI(
      `/partner/api/v1/recharge-rules/corporate/${corporateId}/department/${departmentId}/rule/${ruleId}`,
      "PUT",
      payload,
      (response) => {
        setLoading(false);
        if (response) {
          toast.success("Rule updated successfully!");
          navigate(redirectUrl);
        } else {
          toast.error("Failed to update rule");
        }
      },
      (err) => {
        setLoading(false);
        console.error("Update failed:", err);
        toast.error(err.message || "Failed to update rule");
      }
    );
  };

  const handleCancel = () => {
    let redirectUrl = `/home/customermanager/corporate/rules/${corporateId}`;
    if (accountType) {
      redirectUrl += `?accountType=${accountType}`;
    }
    navigate(redirectUrl);
  };

  if (isLoading && !showForm) {
    return (
      <div className="edit-rule-layout">
        <Sidebar />
        <div className="edit-rule-content">
          <Box className="loading-container">
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 3, color: '#666' }}>
              Loading rule data...
            </Typography>
          </Box>
        </div>
      </div>
    );
  }

  return (
    <div className="edit-rule-layout">
      <Sidebar />
      <div className="edit-rule-content">
        <div className="edit-rule-header">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton 
              onClick={handleBackClick}
              sx={{ 
                color: '#666',
                '&:hover': { 
                  backgroundColor: 'rgba(0, 0, 0, 0.04)' 
                }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <h2 className="edit-rule-title">Edit Department Rules</h2>
              <div className="id-display">
                <Typography variant="caption" sx={{ color: '#666' }}>
                  Corporate ID: {corporateId} | Department ID: {departmentId} | Rule ID: {ruleId}
                </Typography>
                {departmentName && (
                  <Typography variant="caption" sx={{ display: 'block', color: '#3f51b5', fontWeight: 'bold', mt: 0.5 }}>
                    Department: {departmentName}
                  </Typography>
                )}
                {pgid && (
                  <Typography variant="caption" sx={{ display: 'block', color: '#14AE78', fontWeight: 'bold', mt: 0.5 }}>
                    PGID: {pgid}
                  </Typography>
                )}
              </div>
            </Box>
          </Box>
        </div>
        
        <ToastContainer 
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        
        <div className="edit-rule-main">
          {showForm ? (
            <EditRuleComponent
              resetEnabled={resetEnabled}
              carryForwardEnabled={carryForwardEnabled}
              resetConfig={resetConfig}
              handleResetConfigChange={handleResetConfigChange}
              handleResetFrequencyChange={handleResetFrequencyChange}
              handleResetDayChange={handleResetDayChange}
              handleResetDateSelect={handleResetDateSelect}
              carryForwardConfig={carryForwardConfig}
              handleCarryForwardConfigChange={handleCarryForwardConfigChange}
              handleCarryForwardFrequencyChange={handleCarryForwardFrequencyChange}
              handleCarryForwardDayChange={handleCarryForwardDayChange}
              handleCarryForwardDateSelect={handleCarryForwardDateSelect}
              loading={loading}
              onUpdate={handleUpdateRule}
              onCancel={handleCancel}
              existingRuleData={existingRuleData}
            />
          ) : (
            <Alert severity="error">
              Failed to load the edit form. Please check the URL parameters and try again.
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    currentCorporate: state.corporate?.currentCorporate || 
                     state.auth?.currentCorporate || 
                     state.user?.currentCorporate,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(EditRuleContainer);